<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid content-with-v2-countdown"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid
              }"
            >
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
<!--        <div-->
<!--          class="admin-v2-countdown-dock"-->
<!--          :class="{ 'admin-v2-countdown-dock&#45;&#45;at-bottom': isAtPageBottom }"-->
<!--        >-->
<!--          <AdminV2CountdownBanner :action-url="adminV2Url" />-->
<!--        </div>-->
        <KTFooter></KTFooter>
      </div>
    </div>
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import AdminV2CountdownBanner from "@/view/layout/header/AdminV2CountdownBanner.vue";
import { ADMIN_V2_URL } from "@/view/layout/header/adminV2";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import ApiService from "@/core/services/api.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    AdminV2CountdownBanner,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader
  },
  beforeMount() {
    // show page loading
    // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  data() {
    return {
      version: '',
      adminV2Url: ADMIN_V2_URL,
      isAtPageBottom: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateCountdownPosition, { passive: true });
    window.addEventListener("resize", this.updateCountdownPosition);
    this.updateCountdownPosition();
    if (window.ResizeObserver) {
      this.countdownResizeObserver = new window.ResizeObserver(this.updateCountdownPosition);
      this.countdownResizeObserver.observe(document.body);
    }
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    // Simulate the delay page loading
    // setTimeout(() => {
    //   // Remove page loader after some time
    //   this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    // }, 1);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateCountdownPosition);
    window.removeEventListener("resize", this.updateCountdownPosition);
    if (this.countdownResizeObserver) {
      this.countdownResizeObserver.disconnect();
    }
  },
  watch: {
    "$route"() {
      this.$nextTick(this.updateCountdownPosition);
    }
  },
  methods: {
    updateCountdownPosition() {
      const page = document.scrollingElement || document.documentElement;
      this.isAtPageBottom = page.scrollHeight - page.scrollTop - page.clientHeight <= 10;
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return false;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  }
};
</script>

<style>
.content-with-v2-countdown {
  padding-bottom: 120px !important;
}

.admin-v2-countdown-dock {
  position: fixed;
  right: 30px;
  bottom: 10px;
  left: 30px;
  z-index: 95;
  transition: bottom 280ms cubic-bezier(0.22, 1, 0.36, 1);
}

.admin-v2-countdown-dock--at-bottom {
  bottom: 64px;
}

@media (prefers-reduced-motion: reduce) {
  .admin-v2-countdown-dock {
    transition: none;
  }
}

@media (min-width: 992px) {
  .aside-enabled .admin-v2-countdown-dock {
    left: 295px;
  }

  .aside-enabled.aside-minimize:not(.aside-minimize-hover) .admin-v2-countdown-dock {
    left: 100px;
  }
}

@media (max-width: 991.98px) {
  .admin-v2-countdown-dock {
    right: 15px;
    left: 15px;
  }
}
</style>
